export const fetchLocations = (roleId, search = '') =>
    fetch(`${process.env.REACT_APP_API_URL}/api/app/search/locations`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            search,
            limit: 1000
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.results)
        // remove the sub-locations from the array
        // just in case they get leaked from the backend
        .then(locations => locations.filter(l => !l.rootLocation))
        .then(locations => {
            // expand locations keeping groups
            const all = [];
            locations.forEach(loc => !loc.arrayOfSublocations
                ? all.push(loc)
                : all.push(loc)
                && all.push(...loc.arrayOfSublocations.map(loc => {
                    // parse :/
                    // included fields have objectId,
                    // while normal fields have id :(
                    loc.id = loc.objectId;
                    return loc;
                }))
            );
            return all;
        })
        .catch(console.error);
